import { Button } from "../../../atoms/Buttons";
import * as S from "./cmpMainPageContent.styles";
import { ReactComponent as IconArrow } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { useNavigate } from "react-router";

interface CmpMainPageContentProps {}

export const CmpMainPageContent = ({}: CmpMainPageContentProps) => {
  const navigate = useNavigate();
  return (
    <S.CmpMainPageContent>
      <S.CmpMainHeader>
        <span className="colorPrimary">
          회원가입 시 <br /> 운송기사 자격을 등록
        </span>
        해야 업무를 수행할 수 있어요
      </S.CmpMainHeader>
      <S.CmpMaininfoBox>
        <p className="f1">필요한 서류를 미리 준비해주세요!</p>
        <S.CmpMaindataBox>
          <S.NumberBox>
            <S.NumberContent>1</S.NumberContent>
            <S.NumberBoxText> 화물운송종사자격증명 </S.NumberBoxText>
          </S.NumberBox>
          <S.NumberBox>
            <S.NumberContent>2</S.NumberContent>
            <S.NumberBoxText> 운전면허증 </S.NumberBoxText>
          </S.NumberBox>
          <S.NumberBox>
            <S.NumberContent>3</S.NumberContent>
            <S.NumberBoxText> 사업자등록증 </S.NumberBoxText>
          </S.NumberBox>
          <S.NumberBox>
            <S.NumberContent>4</S.NumberContent>
            <S.NumberBoxText> 자동차등록증 </S.NumberBoxText>
          </S.NumberBox>
          <S.NumberDetailBox>
            <S.NumberBox>
              <S.NumberContent>5</S.NumberContent>
              <S.NumberBoxText> 지입계약서 </S.NumberBoxText>
            </S.NumberBox>
            <S.NumberDetailText>
              본인 이름과 차량등록증 소유주명이 다를 때
            </S.NumberDetailText>
          </S.NumberDetailBox>
          <S.NumberDetailBox>
            <S.NumberBox>
              <S.NumberContent>6</S.NumberContent>
              <S.NumberBoxText> 적재물배상책임보험증서 </S.NumberBoxText>
            </S.NumberBox>
            <S.NumberDetailText>5톤 이상 차량시</S.NumberDetailText>
          </S.NumberDetailBox>
        </S.CmpMaindataBox>
      </S.CmpMaininfoBox>
      <S.ButtonBox>
        <div className="small">
          <Button
            type="button"
            color="transparent"
            size="full"
            onClick={() => navigate(-1)}
          >
            취소
          </Button>
        </div>
        <Button
          type="button"
          color="primary"
          size="full"
          onClick={() => navigate("/agreement-page")}
        >
          다음
          <IconArrow width={20} height={20} />
        </Button>
      </S.ButtonBox>
    </S.CmpMainPageContent>
  );
};
